import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const theme: ThemeApp['appComponents']['totalPriceFooter'] = {
  borderTop: `1px solid ${themeUi.semantic.color.border.neutral600}`
};

export default theme;
